import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface ISubHeaderProps {
    data: ISubHeaderLoan
    setIsOpenLink: React.Dispatch<React.SetStateAction<boolean>>
}
// Android activity_moneypool_loan_detail.xml: a big centered
// «مبلغ وام: X تومان» line (18sp), then a two-column block where the
// gray (#A7A7A7) labels and dark values meet at the screen center.
// Labels are ALL gray — even اقساط معوق (no red in the real app).
function InfoRow({ label, value }: { label: string; value: React.ReactNode }) {
    return (
        <div className="flex gap-2">
            <p className="w-1/2 text-sm text-[#A7A7A7] text-left leading-6">
                {label}
            </p>
            <p className="w-1/2 text-sm text-black text-right leading-6">
                {value}
            </p>
        </div>
    )
}
export default function SubHeader({ data, setIsOpenLink }: ISubHeaderProps) {
    const navigate = useNavigate()
    return (
        <div className="bg-white px-4 pt-2 pb-4">
            <p className="mt-1 text-center text-lg text-black">
                مبلغ وام: {data.amount && data.amount.toLocaleString()} تومان
            </p>
            <div className="flex flex-col gap-2.5 py-4">
                <InfoRow
                    label="تاریخ اعطای وام:"
                    value={data.pay_date && ConvertorMiladi(data.pay_date)}
                />
                <InfoRow
                    label="نحوه دریافت کارمزد:"
                    value={
                        data.interest_pay_mode === 'lip_ma'
                            ? 'افزودن به هر قسط' +
                              ` (${Number(data.interest_rate) * 100} درصد)`
                            : 'کسر از مبلغ وام'
                    }
                />
                <InfoRow
                    label="اقساط پرداخت شده:"
                    value={`${data.number_of_repaid_installments} قسط`}
                />
                <InfoRow
                    label="اقساط باقیمانده:"
                    value={`${data.number_of_repayments} قسط`}
                />
                <InfoRow
                    label="اقساط معوق:"
                    value={`${data.number_of_delayed_installments} قسط`}
                />
            </div>
            {/* Android buttons: 40dp tall, solid #74B743, radius 4dp */}
            <div className="flex flex-col gap-2 mt-2">
                <button
                    className="bg-green-1 text-white rounded-[4px] font-bold h-10 px-4 active:scale-[0.98] w-full text-sm"
                    onClick={() => navigate(-1)}
                >
                    اطلاعات عضو
                </button>
                <button
                    className="bg-green-1 text-white rounded-[4px] font-bold h-10 px-4 active:scale-[0.98] w-full text-sm"
                    onClick={() => setIsOpenLink(true)}
                >
                    اشتراک گذاری لینک پرداخت اقساط وام
                </button>
            </div>
        </div>
    )
}
